module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "align-content-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [(_vm.isManagement) ? _c('v-select', {
    attrs: {
      "items": _vm.vendorsList,
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Select the vendor"
    },
    model: {
      value: (_vm.selectedVendor),
      callback: function($$v) {
        _vm.selectedVendor = $$v
      },
      expression: "selectedVendor"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "md8": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "file",
      "accept": ".jpg,.png,.doc,.docx,.pdf,.xls,.xlsx"
    },
    nativeOn: {
      "change": function($event) {
        return _vm.onInvoiceFileChange.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "block": ""
    },
    on: {
      "click": _vm.uploadInvoice
    }
  }, [_vm._v("Upload")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78629737","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VendorsInvoice.vue
// module id = 990
// module chunks = 1